import "normalize.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PageError from "./Pages/PageError";
import PageLogin from "./Pages/PageLogin";
import PageLogout from "./Pages/PageLogout";
import PageTherapists from "./Pages/PageTherapists";

import PrivateRoute from "./components/Auth/PrivateRoute";
import PublicRoute from "./components/Auth/PublicRoute";

function App() {
  return (
    <main>
      <Router>
        <Switch>
          <PrivateRoute path="/" exact component={PageTherapists} />
          <PublicRoute component={PageLogout} path="/logout" exact />
          <PublicRoute
            restricted={true}
            component={PageLogin}
            path="/login"
            exact
          />
          <Route path="*">
            <PageError />
          </Route>
        </Switch>
      </Router>
    </main>
  );
}

export default App;
